  <!-- Action Bar -->
  <div class="wrapper-header sticky-header">
    <h1>{{title}}</h1>
    <div class="action-header-bar">
      <div class="btn-import-export">
        @if (showExportButton) {
          <button matIconButton
                  class="btn-action"
                  (click)="exportAgentToJson()"
                  [disabled]="!isAgentOwner"
                  #tooltip="matTooltip"
                  aria-label="Export Agent"
                  matTooltip="Export Agent"
                  matTooltipPosition="above">
            <mat-icon class="material-symbols-outlined" fontIcon="download" />
          </button>
        }
        @if (showImportButton) {
          <button matIconButton
                  class="btn-action"
                  (click)="openImportDialog()"
                  [disabled]="!isAgentOwner"
                  #tooltip="matTooltip"
                  aria-label="Import Agent"
                  matTooltip="Import Agent"
                  matTooltipPosition="above">
            <mat-icon class="material-symbols-outlined" fontIcon="upload" />
          </button>
      }
      </div>

      <div class="icon-divider"></div>

      <button matIconButton class="btn-action" (click)="cancel()" matTooltip="Cancel" matTooltipPosition="above" aria-label="Cancel">
        <mat-icon class="material-symbols-outlined" fontIcon="cancel" />
      </button>
      <button matIconButton class="btn-action" (click)="reset()" matTooltip="Reset" matTooltipPosition="above" aria-label="Reset">
        <mat-icon class="material-symbols-outlined" fontIcon="refresh"/>
      </button>
      <button matIconButton class="btn-action" (click)="saveAgent()" matTooltip="Save" matTooltipPosition="above" aria-label="Save">
        <mat-icon class="material-symbols-outlined" fontIcon="save" />
      </button>
    </div>
  </div>

<!-- Stepper -->
<!-- Stepper component -->
<app-utility-stepper [steps]="steps"
[currentStep]="currentStep"
[enableValidation]="validateOnRender"
[validationStatus]="validationStatus"
[isLinear]="false"
(stepChange)="onStepChange($event)"
(stepActivate)="onStepActivate($event)"
(validationStatusChange)="onValidationStatusChange($event)">
  @for (step of steps; track step.label; let i = $index) {
    @if (currentStep === i) {
      @switch (step.label) {
        @case (AgentStep.DETAILS) {
          <agent-details></agent-details>
        }
        @case (AgentStep.DEFINITION) {
          <agent-definition></agent-definition>
        }
        @case (AgentStep.API_SETTINGS) {
          <agent-api-settings></agent-api-settings>
        }

        @case (AgentStep.SECURITY) {
          <agent-security></agent-security>
        }

        @case (AgentStep.ADMIN) {
          @if (profileService.userProfile()?.config?.canManageAgents) {
            <agent-admin-settings></agent-admin-settings>
          }
        }
      }
    }
  }
</app-utility-stepper>
